var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDmt(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 46,
    height: 58,
    viewBox: "0 0 46 58",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M31.3411 23.0057L30.4717 25.9716H13.9036L14.7729 23.0057H31.3411ZM23.5683 43L14.2104 31.5455L14.1592 29.3977H18.8126C20.0229 29.3977 21.0541 29.2273 21.9064 28.8864C22.7587 28.5369 23.4107 28.017 23.8624 27.3267C24.3141 26.6278 24.5399 25.75 24.5399 24.6932C24.5399 23.1335 24.0712 21.9105 23.1337 21.0241C22.1962 20.1293 20.7558 19.6818 18.8126 19.6818H13.9036L14.7729 16.8182H18.8126C20.8922 16.8182 22.5967 17.1634 23.9263 17.8537C25.2644 18.5355 26.253 19.473 26.8922 20.6662C27.5399 21.8509 27.8638 23.1932 27.8638 24.6932C27.8638 26.0483 27.5655 27.2969 26.9689 28.4389C26.3808 29.5724 25.4348 30.4844 24.1308 31.1747C22.8354 31.8651 21.1223 32.2102 18.9916 32.2102H18.9149L27.557 42.7955V43H23.5683ZM31.3411 16.8182L30.4717 19.7841L17.432 19.6818L18.3013 16.8182H31.3411Z",
    fill: "#4A4D52"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M34.1407 8.5L39.4975 2M39.4975 2L44.8543 8.5M39.4975 2V19.1364",
    stroke: "#555493",
    strokeWidth: 2.16667
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8 3.13635H34.5289L32.5655 5.13635H8C4.68629 5.13635 2 7.82264 2 11.1364V49.1364C2 52.4501 4.6863 55.1364 8.00001 55.1364H37.2061C40.5198 55.1364 43.2061 52.4501 43.2061 49.1364V11.9755L45.2061 14.0129V49.1364C45.2061 53.5546 41.6244 57.1364 37.2061 57.1364H8.00001C3.58173 57.1364 0 53.5546 0 49.1364V11.1364C0 6.71807 3.58172 3.13635 8 3.13635Z",
    fill: "#4A4D52"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDmt);
export default __webpack_public_path__ + "static/media/dmt.4b2a203bb3955b58b854b8d08bbb4deb.svg";
export { ForwardRef as ReactComponent };